import React from "react";
import EventFormPage from "../components/events/EventFormPage";

const EventEdit = () => <EventFormPage mode="edit" />;

export default EventEdit;
